function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "path1",
  d: "M18.4115 2.00118H9V15.9988H18.4115C18.5574 16.0083 18.7012 15.961 18.8115 15.8673C18.9217 15.7736 18.9895 15.6411 19 15.4988V2.5012C18.9895 2.35889 18.9217 2.22642 18.8115 2.13273C18.7012 2.03904 18.5574 1.99175 18.4115 2.00118Z",
  stroke: "currentColor",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "path2",
  d: "M13 4H17V5.66684H13V4ZM13 9.55544H17V11.2223H13V9.55544ZM13 12.3332H17V14H13V12.3332ZM13 6.77772H17V8.44456H13V6.77772ZM9 4H11.8566V5.66684H9V4ZM9 9.55544H11.8566V11.2223H9V9.55544ZM9 12.3332H11.8566V14H9V12.3332ZM9 6.77772H11.8566V8.44456H9V6.77772Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "path3",
  d: "M10 18L0 15.9965V1.9999L10 0V18Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "path4",
  d: "M6.27076 12.9982L5.15534 10.7188C5.09398 10.5691 5.04982 10.4118 5.02387 10.2505H5.00712C4.96804 10.4172 4.91795 10.5806 4.85722 10.7396L3.73678 13H2L4.06504 9.50181L2.16748 6.00271H3.94361L4.86978 8.09946C4.95007 8.28959 5.01507 8.48682 5.06406 8.68897H5.08248C5.11849 8.55335 5.18632 8.34901 5.28597 8.07957L6.31598 6H7.94557L6.00279 9.47016L8 12.9964H6.27076V12.9982Z",
  fill: "currentColor"
});

function SvgExcelFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "btn_icon_style download_excel_v2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFilled);
export default __webpack_public_path__ + "static/media/excelFilled.a489438f.svg";
export { ForwardRef as ReactComponent };